// extracted by mini-css-extract-plugin
export default {"root":"MultiQuestionStep_root__edI4b","question":"MultiQuestionStep_question__Y2S-h","optionsContainer":"MultiQuestionStep_optionsContainer__hYLz8"};